import { render, staticRenderFns } from "./addData.vue?vue&type=template&id=4f8c92d8&scoped=true"
import script from "./addData.vue?vue&type=script&lang=js"
export * from "./addData.vue?vue&type=script&lang=js"
import style0 from "./addData.vue?vue&type=style&index=0&id=4f8c92d8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8c92d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f8c92d8')) {
      api.createRecord('4f8c92d8', component.options)
    } else {
      api.reload('4f8c92d8', component.options)
    }
    module.hot.accept("./addData.vue?vue&type=template&id=4f8c92d8&scoped=true", function () {
      api.rerender('4f8c92d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/develop/dataManagement/components/addData.vue"
export default component.exports